// Module
var code = "<md-input-container class=\"md-block\" flex>\n    <label>{{'EQUIPMENT.TABS.FORM.EQUIPMENT_ID' | translate}}</label>\n    <input ng-model=\"$ctrl.equipmentId\" ng-change=\"$ctrl.onChange()\">\n</md-input-container>\n";
// Exports
module.exports = code;